const BALANCE_METRIC = "Ativo Total"
const INDICATOR_METRIC = "ROA"

export const normalizeBalancePayload = (payload) => {
    const [records, unit] = Array.isArray(payload?.[0])
        ? payload
        : [payload, "R$"]

    return {
        records: Array.isArray(records) ? records : [],
        unit: unit || "R$",
    }
}

const buildMetricRow = (records, periods, metric) => ({
    id: metric,
    label: metric,
    values: periods.map(
        (period) => records.find(
            (record) => record.DataReferencia === period && record.DadoFinanceiro === metric
        )?.ValorDadoFinanceiro ?? null
    ),
})

export const buildFinancialSeries = (records) => {
    const periods = [...new Set(
        records.map((record) => record.DataReferencia).filter(Boolean)
    )].sort()
    const hasBalance = records.some((record) => record.DadoFinanceiro === BALANCE_METRIC)
    const hasIndicator = records.some((record) => record.DadoFinanceiro === INDICATOR_METRIC)

    return {
        periods,
        balanceRows: hasBalance
            ? [buildMetricRow(records, periods, BALANCE_METRIC)]
            : [],
        indicatorRows: hasIndicator
            ? [buildMetricRow(records, periods, INDICATOR_METRIC)]
            : [],
    }
}
